import { render, staticRenderFns } from "./Lesson2.vue?vue&type=template&id=ef2df414&scoped=true&"
import script from "./Lesson2.vue?vue&type=script&lang=js&"
export * from "./Lesson2.vue?vue&type=script&lang=js&"
import style0 from "./Lesson2.vue?vue&type=style&index=0&id=ef2df414&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2df414",
  null
  
)

export default component.exports